module.exports = __webpack_public_path__ + "img/dc6217a.png";